import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!

  return (_openBlock(), _createBlock(_component_ion_buttons, { class: "galidancia-home-logo" }, {
    default: _withCtx(() => [
      (_ctx.unreadCount > 0)
        ? (_openBlock(), _createBlock(_component_ion_button, {
            key: 0,
            fill: "clear",
            class: "galidancia-home-logo__unread",
            "aria-label": "Mensajes sin leer",
            onClick: _ctx.goMensajes
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                icon: _ctx.mailOutline,
                "aria-hidden": "true"
              }, null, 8, ["icon"]),
              _createVNode(_component_ion_badge, {
                color: "danger",
                class: "galidancia-home-logo__unread-badge"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.unreadBadgeText), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_button, {
        fill: "clear",
        class: "galidancia-home-logo__btn",
        "aria-label": "Ir a inicio",
        onClick: _ctx.goInicio
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: _normalizeClass(["galidancia-home-logo__img", { 'galidancia-home-logo__img--resalta': _ctx.resaltando }]),
            "aria-hidden": "true"
          }, null, 2)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}